import React, { lazy, Suspense } from "react";
import { useInView } from "react-intersection-observer";

const PortafolioComponent = lazy(() => import("../../components/home/portafolio.component"));

const LazyPortafolio = ({ portafolios }: any) => {
  const { ref, inView } = useInView({
    triggerOnce: true,
    threshold: 0.1,
  });


  return (
    <div ref={ref}>
      {inView ? (
        <Suspense fallback={<div>Cargando Portafolio...</div>}>
          <PortafolioComponent portafolios={portafolios} inView={inView} />
        </Suspense>
      ) : (
        <div>Cargando Portafolio...</div>
      )}
    </div>
  );
};

export default LazyPortafolio;
